<template>
  <div>
    <div v-if="error" role="alert" data-testid="error-message">
      <h2 class="text-lg">Error</h2>
      <p>{{ error }}</p>
    </div>
    <LoadingSpinner
      v-if="isLoading"
      data-testid="loading-message"
      class="text-xsoke w-18"
    />
    <ul
      v-if="results"
      class="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16"
      data-testid="tags-search-results"
    >
      <CollectionObjectTeaser
        v-for="result in results.objectRecords"
        :key="result.objectRecordId"
        :object-record="objectRecordDto(result)"
      />
    </ul>
    <p v-if="results && results.totalObjects === 0">
      No related collection objects found.
    </p>
  </div>
</template>

<script>
import api from "@js/eHive/apiClient";
import objectRecordDto from "@js/eHive/dto/objectRecord";
import CollectionObjectTeaser from "./CollectionObjectTeaser.vue";
import LoadingSpinner from "../Core/LoadingSpinner.vue";

export default {
  name: "CollectionObjectTagsSearch",

  components: { CollectionObjectTeaser, LoadingSpinner },

  props: {
    objectRecordId: {
      type: [String, Number],
      required: true
    },
    tags: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isLoading: false,
      error: false,
      results: null
    };
  },

  async created() {
    this.isLoading = true;
    try {
      this.results = await api.getCollection({
        search: "",
        images: "no",
        catalogueType: "",
        tags: this.tags.map(tag => tag.cleanTagName),
        exclude: this.objectRecordId,
        page: 1,
        pageSize: 3
      });
    } catch (err) {
      this.error = err.message;
    }
    this.isLoading = false;
  },

  methods: { objectRecordDto }
};
</script>
